@if (showPanel$ | async) {
<div
  class="error-panel fixed top-0 left-0 right-0 z-50 bg-black text-white max-h-64 overflow-y-auto shadow-2xl"
>
  <div
    class="sticky top-0 bg-black border-b border-gray-700 p-2 flex justify-between items-center"
  >
    <span class="text-xs font-bold">DEBUG LOGS</span>
    <div class="flex gap-2">
      <button
        (click)="prepareLogsForEmail()"
        class="px-2 py-1 text-xs bg-blue-600 hover:bg-blue-700 rounded"
      >
        Send logs
      </button>
      <button
        (click)="clear()"
        class="px-2 py-1 text-xs bg-red-600 hover:bg-red-700 rounded"
      >
        Clear
      </button>
      <button
        (click)="toggle()"
        class="px-2 py-1 text-xs bg-gray-600 hover:bg-gray-700 rounded"
      >
        Hide
      </button>
    </div>
  </div>

  <div class="p-2 space-y-1 font-mono text-xs">
    @for (error of errors$ | async; track error.id) {
    <div class="flex gap-2 pb-1 border-b border-gray-800">
      <span class="text-gray-500 flex-shrink-0">{{ error.timestamp }}</span>
      <span [class]="getLevelColor(error.level) + ' font-bold flex-shrink-0'">
        [{{ error.level.toUpperCase() }}]
      </span>
      <span class="text-gray-200 break-all">{{ error.message }}</span>
    </div>
    } @if ((errors$ | async)?.length === 0) {
    <div class="text-gray-500">No logs yet...</div>
    }
  </div>
</div>
}
